import React, { useContext, useState } from 'react';
import AntButton, { ButtonProps as AntButtonProps } from 'antd/lib/button';
import { CopyTwoTone, SaveOutlined } from '@ant-design/icons';

import RouterLink from './RouterLink';
import useComponentConfiguration from 'DisplayFramework/useComponentConfiguration';
import { useDisplayFrameworkContext } from 'DisplayFramework/hooks/useDisplayFrameworkContext';
import { AuthContext } from './Auth/Auth';
import {
  ParPagComponentRequest,
  updatePageComponent,
} from 'services/displayFramework';
import { Input, notification } from 'antd';

export type ButtonProps = Omit<AntButtonProps, 'children'> & {
  to?: string;
  comcode: string;
  custom?: any;
  Inspectstyle?: React.CSSProperties;
  newVersion?: any;
};

const DuplicateButtonAction = ({
  comcode,
  custom,
  Inspectstyle,
  newVersion,
  ...otherProps
}: ButtonProps) => {
  const { isHidden, label, style } = useComponentConfiguration(comcode);
  const { pagcode, refresh } = useDisplayFrameworkContext();
  const { isInspect } = useContext(AuthContext);
  const [newLabel, setNewLabel] = useState('');

  if (isHidden) {
    return null;
  }

  const handleSaveNewLabel = (comcode: string, labelp: string) => {
    const request: ParPagComponentRequest = {
      comcode: comcode ?? '',
      comformat: '',
      comhint: '',
      comlabel: newLabel === '' ? label : labelp,
      commessage: '',
      complaceholder: '',
      comrequired: false,
      comstyle: '',
      comtype: '',
      pagcode: pagcode ?? '',
    };
    updatePageComponent({ request: request }).then((res) => {
      if (res.code === '200')
        notification.success({
          message: res.message,
          description: res.description,
        });
      else {
        notification.error({
          message: res.message,
          description: res.description,
        });
      }
      refresh();
    });
  };

  const props = {
    ...otherProps,
    children: isInspect ? (
      <Input
        defaultValue={label === '' ? comcode : label}
        size="middle"
        onChange={(event) => {
          event.preventDefault();
          setNewLabel(event.target.value);
        }}
        onClick={(event) => {
          event.preventDefault();
        }}
        style={Inspectstyle ?? { width: '80%' }}
        className="input-inspect"
        addonAfter={
          <SaveOutlined
            onClick={(ev) => {
              ev.preventDefault();
              handleSaveNewLabel(comcode, newLabel);
            }}
          />
        }
      />
    ) : (
      label
    ),
    style,
  };

  if (props.to) {
    return <RouterLink component={AntButton} {...props} />;
  } else {
    return (
      <AntButton
        htmlType="submit"
        {...props}
        icon={
          newVersion ? (
            <CopyTwoTone twoToneColor="#52c41a" />
          ) : (
            <CopyTwoTone twoToneColor="#1890ff" />
          )
        }
        style={
          custom
            ? custom
            : {
                marginLeft: 1,
                marginRight: 1,
                marginBottom: 1,
              }
        }
      />
    );
  }
};

export default DuplicateButtonAction;
